<template src="./Company.html"></template>

<script>
import mixins from "@/Mixins.js";
import ButtonSpinner from "vue-button-spinner";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";

export default {
  mixins: [mixins],
  components: {
    ButtonSpinner,
    WholeMultiselect
  },
  data() {
    return {
      poolAccounts: [],
      idCompany: null,
      company: {},
      bonusBalance: null,
      distributedBalance: null,
      profiles: [],
      titlePopupProfile: "",
      popupProfile: false,
      popupProfileDinamic: false,
      profileSelected: null,
      employerSelected: null,
      popupConfirmProfileChange: false,
      popupChangeBonusStatus: false,
      bonusStatus: false,
      titlePopUpBonusStatus: "",
      titlePopUpExtract: "",
      popUpExtract: false,
      extractEmployee: [],
      popupRecarga: false,
      popupBoleto: false,
      transactions: [],
      invoices: [],
      valor: "",
      payWay: "",
      boletoChargeTax: 0,
      cardChargeTax: 0,
      chargeTax: 0,
      creditCard: {
        ccMes: "",
        ccAno: "",
        ccCvv: "",
        ccNumero: "",
        ccNome: "",
      },
      paymentInfo: {
        method: "",
        token: "",
        upload_register_id: "", // vm.paymentId:
        description: "RECHARGE",
        email: "",
        amount: "",
        months: 1,
      },
      invoice: [],
      number: "",
      complement: "",
      semNumero: false,
      statusMessage: "",
      isLoading: false,
      status: "",
      profileAmount: ""
    };
  },
  mounted() {
    const vm = this;
    vm.Iugu = document.createElement("script");
    vm.Iugu.setAttribute("src", "https://js.iugu.com/v2");
    document.head.appendChild(vm.Iugu);
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      if (vm.testNullUndefinedEmpty(vm.$route.params.id) === false) {
        vm.idCompany = vm.$route.params.id;
        vm.getCompany(vm.$route.params.id);
      }
    },
    getCompany(idCompany) {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "company/companies/" + idCompany, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.company = response.data;
            vm.fetchPoolAccounts();
            vm.fetchBalanceCompany();
            vm.fetchProfiles();
            vm.getCartaoChargeTax();
            vm.getBoletoChargeTax();
          }
        });
    },
    clearButtonLoading() {
      setTimeout(() => {
        this.isLoading = false;
        this.statusMessage = "";
        this.status = "";
      }, 1600);
    },
    recharge() {
      const vm = this;
      vm.valor = null;
      vm.cleanForm();
      vm.payWay = "";
      vm.popupRecarga = true;
    },
    goToProfiles() {
      const vm = this;
      vm.popupProfile = false;
      setTimeout(() => {
        vm.$emit('showProfilePage');
      }, 2000);
    },
    fetchPoolAccounts() {
      const vm = this;
      vm.$vs.loading();
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "pool-profile/employer-company/" +
            vm.idCompany
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.poolAccounts = response.data;
            for (let p in vm.poolAccounts) {
              if (vm.testNullUndefinedEmpty(vm.poolAccounts[p].saldoInicial)) {
                vm.poolAccounts[p].saldoInicial = 0;
                vm.poolAccounts[p].saldoInicialText = vm.maskMoney(
                  vm.poolAccounts[p].saldoInicial
                );
              } else {
                vm.poolAccounts[p].saldoInicialText = vm.maskMoney(
                  vm.poolAccounts[p].saldoInicial
                );
              }
              if (vm.testNullUndefinedEmpty(vm.poolAccounts[p].saldoFinal)) {
                vm.poolAccounts[p].saldoFinal = 0;
                vm.poolAccounts[p].saldoFinalText = vm.maskMoney(
                  vm.poolAccounts[p].saldoFinal
                );
              } else {
                vm.poolAccounts[p].saldoFinalText = vm.maskMoney(
                  vm.poolAccounts[p].saldoFinal
                );
              }
            }
          }
          vm.$vs.loading.close();
        })
        .catch(function () {
          vm.$vs.loading.close();
        });
    },
    openPopUpConfirmChanges() {
      const vm = this;
      vm.popupProfile = false;
      vm.popupProfileDinamic = false;
      vm.popupConfirmProfileChange = true;
    },
    changeProfile(tr) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(tr.poolProfileId)) {
        vm.titlePopupProfile =
          "Atribuir Perfil ao funcionário " + tr.patientName;
      } else {
        vm.titlePopupProfile = "Modificar Perfil" + tr.poolProfileName;
        vm.profileSelected = vm.profiles.find(p => {return p.id === tr.poolProfileId;});
      }
      vm.employerSelected = tr.patientId;
      vm.popupProfile = true;
    },
    changeProfileDinamic(tr) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(tr.poolProfileId)) {
        vm.titlePopupProfile =
          "Atribuir o valor ao funcionário " + tr.patientName;
      } else {
        vm.titlePopupProfile = "Modificar Perfil" + tr.poolProfileName;
        vm.profileSelected = tr.poolProfileId;
      }
      vm.employerSelected = tr.patientId;
      vm.popupProfileDinamic = true;
    },
    fetchProfiles() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "pool-profile/pool-company/" +
            vm.idCompany,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            let poolcompany = response.data;
            for (let p in poolcompany) {
              vm.profiles[p] = poolcompany[p].profile;
            }
          }
        });
    },
    postProfile() {
      if (this.profiles.length === 0) {
        this.popupProfile = false;
        this.popupProfileDinamic = false;
        this.popupConfirmProfileChange = false;
        this.$swal({
                title: "Atenção!",
                text: "Para executar esta operação é necessário que o colaborador esteja vinculado ao um perfil. Porém não existem perfis cadastrados para esta empresa. Clique no botão abaixo e você será redirecionado para a página de Perfis.",
                icon: "warning",
              }).then(function () {
                this.$emit('showProfilePage');
              });
      } else {
        let profile = {
          patientId: this.employerSelected,
          poolProfileId: this.profileSelected == undefined ? null : this.profileSelected.id,
          profileAmount: this.profileAmount,
        };
        this.isLoading = true
        this.axios
          .post(
            this.$store.state.filooServer +
              "pool-profile/transaction/" +
              this.idCompany,
            profile,
            {
              headers: { Authorization: this.$session.get("bearer") },
            }
          )
          .then(({ status }) => {
            if (status == 200) {
              this.popupProfile = false;
              this.popupConfirmProfileChange = false;
              this.$swal({
                title: "Sucesso!",
                text: "Operação realizada com sucesso.",
                icon: "success",
              }).then(function () {
                this.fetchPoolAccounts();
                this.fetchBalanceCompany();
                this.fetchProfiles();
              });
            }
          })
          .catch(function (error) {
            this.popupProfile = false;
            this.popupConfirmProfileChange = false;
            this.$swal({
              title: "Atenção!",
              text: error.response.data.message,
              icon: "error",
            });
          })
          .finally(() => this.isLoading = false);
      }
    },
    confirmChangeBonusStatus() {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "pool-profile/status/" +
            vm.employerSelected +
            "/" +
            vm.bonusStatus
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.popupChangeBonusStatus = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Operação realizada com sucesso.",
              icon: "success",
            }).then(function () {
              vm.fetchPoolAccounts();
              vm.fetchBalanceCompany();
              vm.fetchProfiles();
            });
          }
        })
        .catch(function () {
          vm.popupChangeBonusStatus = false;
        });
    },
    getBonusStatusEmployee(employee) {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "pool-profile/status/" +
            employee.userId
        )
        .then(function (response) {
          if (response.status == 200) {
            if (vm.testNullUndefinedEmpty(response.data)) {
              vm.bonusStatus = false;
            } else {
              if (response.data === true) {
                vm.bonusStatus = true;
              } else {
                vm.bonusStatus = false;
              }
            }
            vm.employerSelected = employee.userId;
            vm.titlePopUpBonusStatus =
              "Ative ou Inative o recebimento do bônus para o " +
              employee.patientName;
            vm.popupChangeBonusStatus = true;
          }
        })
        .catch(function (error) {
          vm.popupChangeBonusStatus = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível completar essa operação. Por favor contacte o administradotor do sistema. " +
              error.response.data.message,
            icon: "error",
          });
        });
    },
    fetchBalanceCompany() {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "pool-profile/balance/" +
            vm.idCompany,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.bonusBalance = response.data.bonusBalance;
            vm.distributedBalance = response.data.distributedBalance;
          }
        });
    },
    getExtract(employee) {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "pool-profile/extract/" +
            employee.userId
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.extractEmployee = response.data.content;
            for (let e in vm.extractEmployee) {
              vm.extractEmployee[e].typeBr =
                vm.extractEmployee[e].type == "CREDIT" ? "Crédito" : "Débito";
              vm.extractEmployee[e].statusBr =
                vm.extractEmployee[e].status == "AUTHORIZED"
                  ? "Autorizado"
                  : "Não autorizado";
            }
            vm.popUpExtract = true;
          }
        });
    },
    payBoleto() {
      const vm = this;
      let valid = true;
      vm.isLoading = true;
      if (vm.number == "") {
        vm.semNumero = true;
        valid = false;
        vm.statusMessage = "Insira um número.";
        setTimeout(() => {
          vm.clearButtonLoading();
        }, 1500);
      }
      if (vm.valor == 0) {
        vm.$vs.notify({
          title: "Atenção",
          text: "Favor insiserir um valor",
          color: "danger",
          time: 4000,
          position: "top-right",
        });
        valid = false;
        vm.statusMessage =
          "Insira um valor. O valor mínimo de recarga é R$10,00.";
        setTimeout(() => {
          vm.clearButtonLoading();
        }, 1500);
      }
      if (vm.valor !== 0 && vm.valor < 10) {
        vm.$vs.notify({
          title: "Atenção",
          text: "O valor mínimo de recarga é R$10,00",
          color: "danger",
          time: 4000,
          position: "top-right",
        });
        valid = false;
        vm.statusMessage =
          "Insira um valor. O valor mínimo de recarga é R$10,00.";
        setTimeout(() => {
          vm.clearButtonLoading();
        }, 1500);
      }
      if (valid == true) {
        vm.postCharge();
      } else {
        vm.$vs.notify({
          title: "Atenção",
          time: 4000,
          text:
            "Campos obrigatórios não preenchidos ou inválidos, revise e tente novamente!",
          color: "warning",
          position: "top-right",
        });
      }
    },

    initIUGU() {
      // eslint-disable-next-line
      Iugu.setAccountID("01F2C1AD387143F5BBFC8FBD20EAD02A");
      // eslint-disable-next-line
      Iugu.setup();
      // eslint-disable-next-line
      Iugu.setTestMode(this.$store.state.filooIuguTest);
    },
    cleanForm() {
      const vm = this;
      vm.creditCard.ccNumero = "";
      vm.creditCard.ccCvv = "";
      vm.creditCard.ccMes = "";
      vm.creditCard.ccAno = "";
    },
    payCartao() {
      const vm = this;
      vm.isLoading = true;
      if (vm.valor >= 0 && vm.valor < 10) {
        setTimeout(() => {
          this.isLoading = true;
          this.statusMessage = 'O valor mínimo de recarga é de R$10,00"';
          this.status = "";
        }, 1300);
        setTimeout(() => {
          vm.clearButtonLoading();
        }, 1300);
        vm.$vs.notify({
          title: "Atenção",
          text: "O valor mínimo de recarga é de R$10,00",
          color: "warning",
          position: "top-right",
        });
      } else {
        vm.paymentInfo.method = "credit_card";
        vm.paymentInfo.months = 1;
        vm.paymentInfo.email = vm.company.email;
        vm.paymentInfo.amount = vm.valor;
        vm.initIUGU();
        var full = vm.creditCard.ccNome.split(" ");
        // eslint-disable-next-line
        var iuguCreditCard = Iugu.CreditCard(
          vm.creditCard.ccNumero,
          vm.creditCard.ccMes,
          vm.creditCard.ccAno,
          full[0],
          full.pop(),
          vm.creditCard.ccCvv
        );
        if (iuguCreditCard.valid()) {
          // eslint-disable-next-line
          Iugu.createPaymentToken(iuguCreditCard.toData(), function (response) {
            if (response && response.id) {
              vm.paymentInfo.token = response.id;
              vm.axios
                .post(
                  vm.$store.state.filooServer + "payment/charge",
                  vm.paymentInfo,
                  {
                    headers: {
                      Authorization: vm.$session.get("bearer"),
                    },
                  }
                )
                .then(function (responsee) {
                  vm.popupRecarga = false;
                  if (responsee.data.status == "Autorizado") {
                    vm.clearButtonLoading();
                    vm.popupRecarga = false;
                    vm.$swal("Sucesso!", "Saldo carregado", "success").then(
                      function () {
                        vm.fetchPoolAccounts();
                        vm.fetchBalanceCompany();
                        vm.fetchProfiles();
                      }
                    );
                  } else {
                    if (responsee.data.status == "Transação negada") {
                      this.isLoading = true;
                      this.statusMessage =
                        "Transação negada, confira os dados inseridos e tente novamente. Caso o problema persistir contacte o administrador do sistema.";
                      this.status = "";

                      setTimeout(() => {
                        vm.clearButtonLoading();
                      }, 1500);
                    }
                  }
                });
            } else {
              vm.clearButtonLoading();
              vm.popupRecarga = false;
              vm.$swal(
                "Atenção!",
                "Erro na transação, por favor contacte o administrador do sistema.",
                "error"
              );
            }
          });
        } else {
          this.isLoading = true;
          this.statusMessage =
            "Cartão de crédito inválido, insira um cartão válido e tente novamente.";
          this.status = "";

          setTimeout(() => {
            vm.clearButtonLoading();
          }, 1400);
        }
      }
    },
    getBoletoChargeTax() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "parameters/tax/BOLETO_CHARGE_TAX", {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          vm.boletoChargeTax = response.data;
        });
    },
    getCartaoChargeTax() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "parameters/tax/CARD_CHARGE_TAX", {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          vm.cardChargeTax = response.data;
        });
    },
    postCharge() {
      const vm = this;
      var payload = {
        amount: vm.valor,
        email: vm.company.email,
        method: "bank_slip",
        months: 1,
        payer: {
          name: vm.company.companyName,
          cpf_cnpj: vm.company.cnpj,
          address: vm.company.address,
        },
        token: null,
      };
      payload.payer.address.complement = vm.complement;
      payload.payer.address.number = vm.number;
      this.axios
        .post(vm.$store.state.filooServer + "payment/charge", payload, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.invoice = response.data;

            if (vm.invoice.invoice_url !== null) {
              vm.clearButtonLoading();
              vm.boleto_sucesso();
            } else {
              vm.clearButtonLoading();
              vm.popupRecarga = false;
              vm.$vs.notify({
                title: "Atenção!",
                text:
                  "Não foi possível realizar a recarga, contacte o administrador do sistema.",
                color: "danger",
                position: "top-right",
              });
            }
          }
        })
        .catch(function () {
          vm.clearButtonLoading();
          vm.popupRecarga = false;
          vm.$vs.notify({
            title: "Atenção!",
            text:
              "Não foi possível realizar a recarga, contacte o administrador do sistema.",
            color: "danger",
            position: "top-right",
          });
        });
    },
    boleto_sucesso() {
      const vm = this;
      vm.popupRecarga = false;
      vm.popupBoleto = true;
    },
  },
};
</script>

<style lang="scss" src="./Company.scss">
</style>
